<script setup>
import { HModal, HTextarea, HButton, HRow, HCol } from '@pixul/hephaestus';
</script>

<template>
  <HModal
    show
    @close='closeModal'
  >
    <template #title>
      <p>{{ $t('report-bug.technical-support') }}</p>
    </template>

    <template #default>
      <HCol gap='12'>
        <p>{{ $t('report-bug.title') }}</p>
        <HTextarea
          v-model='message'
          clearable
          :model-value='newFileName'
          placeholder='Message'
          type='textarea'
          @update:model-value='(value) => newFileName = value'
        />
        <HRow
          gap='6'
          justify-content='space-between'
        >
          <HButton
            type='danger'
            @click='closeModal'
          >
            <p>{{ $t('report-bug.cancel') }}</p>
          </HButton>
          <HButton
            type='primary'
            @click='sendMail'
          >
            <p>{{ $t('report-bug.send') }}</p>
          </HButton>
        </HRow>
      </HCol>
    </template>
  </HModal>
</template>

<script>

import { UAParser }     from 'ua-parser-js';
import config           from '@/config';
import { mapStores }    from 'pinia';
import { useUserStore } from '@/store/user';
import Service          from '@/api/service';

export default {
  name     : 'ReportBug',
  inject   : ['displayAlert'],
  emits    : ['close'],

  data() {
    
    return {
      message   : '',
      version   : config.version,
      mailInfos : {
        from    : {
          name    : 'Comms Support Request',
          address : 'comms-support'
        },
        to      : ['it@leggett.fr'],
        replyTo : '',

        'encoding' : 'utf-8'
      }
    };
  },

  computed : {
    ...mapStores(useUserStore)
  },

  methods : {
    closeModal() {
        
      this.$emit('close');
    },

    sendMail() {
        
      const parser = new UAParser();
      const user = this.userStore.user;
      this.mailInfos.replyTo = user.email;
      this.mailInfos.subject = `${ user.firstName } ${ user.lastName } needs support on Comms`;
      this.mailInfos.html = `<html>
                <body>
                    <div>Firstname : ${ user.firstName }</div>
                    <div> Lastname : ${ user.lastName }</div>
                    <div>Id: ${ user.id }</div>
                    <div>Email : ${ user.email }</div>
                    <div>Phone : ${ user.phones[0] ? user.phones[0].number : 'None' }</div>
                    <div>Browser : ${ parser.getBrowser().name }</div>
                    <div>Version : ${ parser.getBrowser().version }</div>
                    <div>OS : ${ parser.getOS().name } ${ parser.getOS().version }</div>
                    <div>Page : ${ window.location.href }</div>
                    <div>Comms version : ${ this.version }</div>
                    <div>Message : ${ this.message }</div>
                </body>
            </html>`;
      try {
        Service.sendToSupport(user.tenantId, this.mailInfos);
        this.displayAlert({
          type     : 'success',
          messages : [this.$t('message.bugSent')],
          timeout  : 5000
        });

        this.$emit('close');
      } catch {
        this.displayAlert({
          type     : 'error',
          messages : [this.$t('message.bugFailed')],
          timeout  : 5000
        });
      }
    }
  }
};

</script>